import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import * as actionTypes from "../../../store/actions/actionTypes";
import useAdmissionListNavigation from "../../../utils/admissionListNavigation";

const AdmissionList_Search = () => {
    const {pushAdmissionsListUrl} = useAdmissionListNavigation();
    const dispatch = useDispatch();
    const {keyword} = useSelector(state => state.admissionList);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        if (keyword) {
            setSearchValue(keyword);
        } else {
            setSearchValue('');
        }
    }, [keyword]);
    // console.log('[AdmissionList_Search]', keyword);

    const searchEnabled = () => (searchValue.length > 1) || ((searchValue === '') && (keyword !== '') && (keyword !== null) && (keyword !== false));

    const search = event => {
        if (searchEnabled) {
            pushAdmissionsListUrl(null, null, searchValue, null, null, false, false);
            dispatch({type: actionTypes.ADMISSIONS_LIST_SET_KEYWORD, keyword: searchValue})
        }
        event.preventDefault();
    }

    return (
        <div className={`search-holder${keyword ? ' search-active' : ''}`}>
            <form className="search-form" onSubmit={search}>
                <div className="input-row">
                    <input type="search" className="form-control" placeholder="Search..." onChange={(event) => setSearchValue(event.target.value)} value={searchValue} />
                </div>
                <button className="btn btn-sm btn-search" disabled={!searchEnabled()} onClick={search}><i className="icon ico-zoom" /></button>
            </form>
        </div>
    );
}

export default AdmissionList_Search;